import React, { forwardRef, memo } from 'react';
import PropTypes from 'prop-types';
import Header from './headerResults';
import Row from './rowResults';
import { useReportResult } from './hooks';
import { StyleTable } from './styles';

function SubResults({
  caption, header, footer, styles, body, onContextMenu,
}) {
  return (
    <>
      {caption && (
      <h3>{caption}</h3>
      )}
      <StyleTable
        addStyles={Object.keys(styles)
          .map((s) => `.${s}  { ${styles[s]}}`)}
      >
        <Header
          lines={header}
        />
        <tfoot>
          {footer.map((row) => (
            <tr key={row[0].row_num}>
              <td>&nbsp;</td>
              {row.map((cell) => (
                <td
                  key={`row-${cell.row_num} col-${cell.col_num}`}
                  colSpan={cell.colspan}
                  rowSpan={cell.rowspan}
                  className={`FooterOfTable ${cell.className} ${cell.styles ? cell.styles.join(' ') : ''}`}
                >
                  {cell.repr}
                </td>

              ))}
            </tr>
          ))}
        </tfoot>
        <tbody>
          {body.map((cells) => (
            <Row
              key={cells[0].row_num}
              cells={cells}
              visible
              onContextMenu={onContextMenu}
            />
          ))}

        </tbody>

      </StyleTable>
    </>
  );
}

SubResults.propTypes = {
  caption: PropTypes.string,
  header: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))),
  footer: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))),
  body: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))),
  styles: PropTypes.shape({}),
  onContextMenu: PropTypes.func.isRequired,
};

SubResults.defaultProps = {
  caption: null,
  header: [],
  footer: [],
  body: [],
  styles: {},
};

const MSubResults = memo(SubResults);

const Results = forwardRef(({ result, caption, onContextMenu }, ref) => {
  const { header, body, footer } = useReportResult(result);
  return (
    <div id="print-area-rep" ref={ref}>
      <MSubResults
        body={body}
        caption={caption}
        footer={footer}
        header={header}
        styles={result.styles}
        onContextMenu={onContextMenu}
      />
    </div>
  );
});

Results.propTypes = {
  result: PropTypes.shape({
    meta: PropTypes.shape({}),
    data: PropTypes.shape({}),
    styles: PropTypes.shape({}),
  }),
  caption: PropTypes.string,
  onContextMenu: PropTypes.func.isRequired,
};

Results.defaultProps = {
  result: null,
  caption: null,
};

export default Results;
